import { render, staticRenderFns } from "./UnsubscribeReasons.vue?vue&type=template&id=63208356"
import script from "./UnsubscribeReasons.vue?vue&type=script&lang=js"
export * from "./UnsubscribeReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63208356')) {
      api.createRecord('63208356', component.options)
    } else {
      api.reload('63208356', component.options)
    }
    module.hot.accept("./UnsubscribeReasons.vue?vue&type=template&id=63208356", function () {
      api.rerender('63208356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subscription/unsubscription/UnsubscribeReasons.vue"
export default component.exports